import React, { useEffect, useState } from "react";
import { useShoppingCart } from "../context/ShoppingCartContext";

export default function CartExpiryCountdown() {
  const { cartExpire, cartItems, order } = useShoppingCart();
  const [remaining, setRemaining] = useState<number>(0);

  useEffect(() => {
    if (!order?.shoppingCartExpire || !cartExpire || cartItems.length === 0) {
      setRemaining(0);
      return;
    }

    const expiry =
      cartExpire instanceof Date ? cartExpire : new Date(cartExpire);

    const tick = () => {
      const now = new Date();
      const ms = Math.max(0, expiry.getTime() - now.getTime());
      setRemaining(ms);
    };

    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [cartExpire, cartItems.length, order?.shoppingCartExpire]);

  // Only display when backend provided shoppingCartExpire
  if (!order?.shoppingCartExpire || cartItems.length === 0 || remaining <= 0) {
    return null;
  }

  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return (
    <span>{`${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}</span>
  );
}
